module.exports = __webpack_public_path__ + "static/ali-front-a21a0bb01f9a122594eddda2a4b2233c.jpg";